<template>
    <aside :class="{ closed: sidebarClosed }">
        <nav>
            <ul class="list-unstyled mb-0">
                <li
                    v-for="item in nav"
                    :key="item.id"
                >
                    <router-link
                        :to="{ name: item.id }"
                        :class="[ 'nav-item--' + item.id, item.classes ]"
                        class="nav-item"
                        @click.native="closeSidebar()"
                    >
                        <SVGSprite
                            v-if="item.icon"
                            :name="item.icon"
                            class="nav-item__icon"
                        />
                        <span class="nav-item__title">{{ item.title }}</span>
                    </router-link>
                </li>
            </ul>
        </nav>
        <a
            href="#"
            class="toggle-sidebar"
            @click.prevent="toggleSidebar()"
        >
            <SVGSprite
                name="close"
                class="toggle-sidebar__icon d-inline-block d-md-none"
            />
            <SVGSprite
                name="menu"
                class="toggle-sidebar__icon d-none d-md-inline-block"
            />
        </a>
    </aside>
</template>

<script>
export default {
    name: 'Sidebar',
    data() {
        return {
            nav: [
                {
                    id: 'dashboard',
                    title: 'Dashboard',
                    icon: 'dash'
                },
                {
                    id: 'search-properties',
                    title: 'Search Properties',
                    icon: 'search'
                },
                {
                    id: 'my-properties',
                    title: 'My Properties',
                    icon: 'home'
                },
                {
                    id: 'saved-properties',
                    title: 'Saved Properties',
                    icon: 'heart'
                },
                {
                    id: 'my-calendar',
                    title: 'My Calendar',
                    icon: 'calendar'
                },
                {
                    id: 'messages',
                    title: 'Messages',
                    icon: 'messages'
                },
                {
                    id: 'notifications',
                    title: 'Notifications',
                    icon: 'bell'
                },
                {
                    id: 'my-profile',
                    title: 'My Profile',
                    icon: 'my-profile'
                },
                {
                    id: 'logout',
                    title: 'Logout',
                    icon: 'logout'
                }
            ],
            sidebarClosed: false,
            windowWidth: 0
        };
    },
    watch: {
        windowWidth(newHeight) {
            if (newHeight <= 768) {
                this.sidebarClosed = true;
            } else {
                this.sidebarClosed = false;
            }
        }
    },
    mounted() {
        this.windowWidth = window.innerWidth;

        this.$root.$on('headerToggleSidebar', () => {
            this.toggleSidebar();
        });

        this.$nextTick(() => {
            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth;
            });
        });
    },
    methods: {
        toggleSidebar() {
            this.sidebarClosed = !this.sidebarClosed;
        },
        closeSidebar() {
            if (this.windowWidth <= 768) {
                this.sidebarClosed = true;
            }
        }
    }
};
</script>

<style lang="scss">

.sidebar {
    width: 25rem;
    position: relative;
    transition: width .5s, transform .5s;
    position: fixed;
    top: 0;
    left: 100%;
    height: 100%;
    z-index: 9;
    transform: translateX(-25rem);

    @include media-breakpoint-up(md) {
        transition: width .8s, transform .8s;
        position: relative;
        top: auto;
        left: auto;
        height: auto;
        transform: none;
    }

    nav {
        overflow: hidden;
        padding-top: 7.5rem;
    }

    &.closed {
        transform: translateX(0);

        @include media-breakpoint-up(md) {
            width: 6rem;

            .nav-item {
                &__title {
                    opacity: 0;
                    transition: opacity .3s;
                }
            }
        }
    }
}

.nav-item {
    display: block;
    padding: 2rem;
    background: transparent;
    color: theme-color('light-grey');
    border-bottom: 1px solid lighten(theme-color('dark-grey'), 5%);
    transition: color .3s ease, background .3s ease;
    white-space: nowrap;
    position: relative;

    &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 5px;
        background: transparent;
        transition: background .3s ease;
    }

    &.router-link-exact-active {
        color: white;
        background: #6b6c70;

        &::before {
            background: theme-color('primary');
        }

        @include media-breakpoint-up(lg) {
            &:hover {
                color: white;
                background: #6b6c70;

                &::before {
                    background: theme-color('primary');
                }
            }
        }
    }

    li:last-of-type & {
        border-bottom: 0;
    }

    &:hover {
        text-decoration: none;

        @include media-breakpoint-up(lg) {
            color: white;
            background: #6b6c70;
        }
    }

    &__icon {
        width: 1.7rem;
    }

    &__title {
        margin-left: 2rem;
        font-weight: 600;

        @include media-breakpoint-up(md) {
            transition: opacity .3s linear .8s;
        }
    }
}

// Sidebar toggle
.toggle-sidebar {
    position: absolute;
    padding: 1rem;
    top: 1.5rem;
    right: 1.5rem;
    line-height: normal;
    background: transparent;

    &__icon {
        width: 1.5rem;
        color: white;
    }
}

// buttons
@include media-breakpoint-down(sm) {
    .page-dashboard {
        .btn:not(.btn--sm) {
            width: 100%;
        }
    }
}
</style>
